import { Dispatch } from 'redux';

import { Api } from '../../../../api';
import { AppState } from '../../../../store/models/app-state';
import { Contact } from '../../../../common/models/contact';

export const DEMANDS_TOPICS_RECEIVED = 'DEMANDS_TOPICS_RECEIVED';
export const DEMANDS_TOPICS_REQUESTED = 'DEMANDS_TOPICS_REQUESTED';
export const DEMANDS_TOPICS_RESET = 'DEMANDS_TOPICS_RESET';
export const DEMANDS_TOPICS_ASSIGN_CONTACTS = 'DEMANDS_TOPICS_ASSIGN_CONTACTS';
export const DEMANDS_TOPICS_CHANGE_INTEREST = 'DEMANDS_TOPICS_CHANGE_INTEREST';

export const resetDemandOverview = () => ({
    type: DEMANDS_TOPICS_RESET,
});

export const fetchDemandTopics = (searchParams: URLSearchParams) => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const customerAccountId = getState().account?.id;

        if (!customerAccountId) {
            return;
        }

        dispatch({ type: DEMANDS_TOPICS_REQUESTED });

        const response = await api.demand.DemandTopics.cget(customerAccountId, searchParams);

        if (response.success) {
            dispatch({ type: DEMANDS_TOPICS_RECEIVED, topics: response.result });
        }
    };
};

export const assignContacts = (topicId: number, contacts: Contact[]) => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const customerAccountId = getState().account?.id;

        if (!customerAccountId) {
            return;
        }

        dispatch({ type: DEMANDS_TOPICS_ASSIGN_CONTACTS, topicId, contacts });

        await api.demand.DemandTopics.assignContacts(
            topicId,
            contacts.map(c => c.id)
        );
    };
};

export const noInterest = (topicId: number) => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const customerAccountId = getState().account?.id;

        if (!customerAccountId) {
            return;
        }

        dispatch({ type: DEMANDS_TOPICS_CHANGE_INTEREST, topicId });

        await api.demand.DemandTopics.changeInterest(topicId, false);
    };
};
